import styled from 'styled-components';

export const DockPanelItem = styled.div`
  margin: 2rem;
`;
